var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 105.83 105.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7249 0 0 1.7249 -49.815 -18.539)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.577,
    cy: 41.381,
    rx: 29.536,
    ry: 29.6,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.3009
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.746 39.883a12.034 12.899 0 0 1-2.2005 16.471 12.034 12.899 0 0 1-15.517 0.44358 12.034 12.899 0 0 1-3.0163-16.322z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.241 43.499-0.22895-3.0211 10.726-18.402 10.017 17.819-0.28707 3.3431z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.812089ecccb795d9ad6c00d35526f776.svg";